<div class="dialog-container">
  <!-- Header -->
  <div class="dialog-header">
    <oph-x-button class="cb-launch-challenge-dialog__close-button" (click)="onBack()" title="Close dialog" />
    <div class="header-icon-wrapper">
      <img src="assets/img/icons/challenge-builder/launch-bg.png" alt="" class="header-bg" />
      <img src="assets/img/icons/challenge-builder/launch.png" alt="Launch" class="header-rocket" />
    </div>
    <div class="header-text">
      <h2 class="header-title">Launch your challenge</h2>
      <p class="header-description">Finish setting up your challenge.</p>
    </div>
  </div>

  <!-- Content -->
  <div class="dialog-content">
    <!-- Challenge Name -->
    <div class="form-group">
      <label class="form-label">Challenge Name</label>
      <input type="text" class="form-input" [value]="label()" (input)="label.set($any($event.target).value)" />
    </div>

    <!-- Start Date + Cycle Length Row -->
    <div class="date-cycle-row">
      <div class="form-group start-date-group">
        <label class="form-label">Start Date</label>
        <button class="form-select-button" [matMenuTriggerFor]="startDateMenu" #startDateTrigger="matMenuTrigger">
          <mat-icon svgIcon="calendar-filled" class="calendar-icon"></mat-icon>
          <span>{{ startDateDisplay() }}</span>
        </button>
        <mat-menu #startDateMenu="matMenu" panelClass="calendar-menu">
          <div class="calendar-menu-content" (click)="$event.stopPropagation()">
            <mat-calendar
              [selected]="startDateTime()"
              [minDate]="minDate"
              [headerComponent]="customHeader"
              (selectedChange)="onStartDateChange({value: $event}); startDateTrigger.closeMenu()"
            ></mat-calendar>
          </div>
        </mat-menu>
      </div>

      <div class="form-group cycle-length-group">
        <label class="form-label">Cycle Length</label>
        <div class="cycle-length-display">{{ cycleLengthDisplay() }}</div>
      </div>
    </div>

    <!-- Pass Level -->
    <div class="form-group pass-level-group">
      <h3 class="section-title">Pass Level</h3>
      <p class="section-description">With 100% being perfection, set your success threshold.</p>
      <div class="slider-row oph-slider-container">
        <mat-slider [min]="0" [max]="100" [step]="5" class="pass-level-slider">
          <input matSliderThumb [value]="cycleSuccessScore()" (input)="onSliderChange($any($event.target).value)" />
        </mat-slider>
        <span class="slider-value">{{ sliderValueDisplay() }}</span>
      </div>
    </div>

    <!-- Level Up
    <div class="form-group level-up-group">
      <h3 class="section-title">Level Up</h3>
      <p class="section-description">How many successful cycles until we increase the difficulty of your challenge?</p>
      <div class="level-up-row">
        <button type="button" class="form-select-button cycles-dropdown" [matMenuTriggerFor]="cyclesMenu">
          {{ levelProgressThreshold() }}
          <mat-icon svgIcon="chevron-down"></mat-icon>
        </button>
        <mat-menu #cyclesMenu="matMenu" class="oph-select-menu">
          @for (option of levelProgressThresholdOptions; track option) {
            <button type="button" (click)="onCyclesPerLevelChange(option)" class="oph-select-menu-item">
              {{ option }}
            </button>
          }
        </mat-menu>
        <span class="cycles-label">consecutive successful cycles</span>
      </div>
    </div> -->
  </div>

  <!-- Footer -->
  <div class="dialog-footer">
    <oph-button
      color="gray"
      appearance="outline"
      [style]="{'border-width': '1px', 'border-radius': '8px', width: '121px', height: '46px'}"
      (buttonClick)="onBack()"
      >Back</oph-button
    >
    <oph-button
      color="green"
      [style]="{'border-radius': '8px', width: '159px', height: '46px'}"
      [disabled]="!label().trim()"
      [loading]="loading()"
      (buttonClick)="onStartChallenge()"
      >Start Challenge</oph-button
    >
  </div>
</div>
